/**
 * Lista de provedores de e-mail genéricos/gratuitos mais comuns.
 */
export const PUBLIC_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'hotmail.com',
  'hotmail.com.br',
  'outlook.com',
  'outlook.com.br',
  'live.com',
  'yahoo.com',
  'yahoo.com.br',
  'icloud.com',
  'me.com',
  'mac.com',
  'bol.com.br',
  'uol.com.br',
  'terra.com.br',
  'ig.com.br',
  'globo.com',
  'globomail.com',
  'r7.com',
  'zipmail.com.br',
  'proton.me',
  'protonmail.com',
  'zoho.com',
  'mail.com',
  'aol.com',
]);

export interface CompanyEnrichmentResult {
  isCorporate: boolean;
  domain?: string;
  website?: string;
  companyName?: string;
}

/**
 * Analisa o e-mail do usuário e extrai dados corporativos (URL e Nome da empresa) caso seja um domínio empresarial.
 */
export function getCompanyInfoFromEmail(email?: string | null): CompanyEnrichmentResult {
  if (!email || !email.includes('@')) {
    return { isCorporate: false };
  }

  const domain = email.split('@')[1]?.toLowerCase().trim();
  if (!domain || PUBLIC_EMAIL_DOMAINS.has(domain)) {
    return { isCorporate: false };
  }

  // Extrai o nome da empresa a partir do primeiro segmento do domínio
  // Ex: "totvs.com.br" -> "Totvs", "meta.com" -> "Meta", "banco-inter.com.br" -> "Banco Inter"
  const rawName = domain.split('.')[0];
  const companyName = rawName
    .replace(/[-_]/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return {
    isCorporate: true,
    domain,
    website: `https://${domain}`,
    companyName,
  };
}
